import { render, staticRenderFns } from "./WidgetsComponent.vue?vue&type=template&id=dbb3f804&scoped=true&lang=html&"
import script from "./WidgetsComponent.vue?vue&type=script&lang=js&"
export * from "./WidgetsComponent.vue?vue&type=script&lang=js&"
import style0 from "./WidgetsComponent.vue?vue&type=style&index=0&id=dbb3f804&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb3f804",
  null
  
)

export default component.exports